import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/cursos-en-espanol/drogas-y-alcohol.jpg";
import "./FourHourBDI.css";

const CursoAlcoholDrogas = () => {
    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">
                                Curso de Alcohol y Drogas para obtener la licencia por primera vez
                            </h1>
                        </div>
                    </div>
                </div>
            </section>

            <main className="bdi-page mb-3">
                <div className="container mt-5">
                    <div className="row mb-5">
                        <div className="col-12">
                            <ShellCard>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <h3 className="mb-4 text-warning">Descripción del Curso</h3>
                                            <p>
                                                El curso de Alcohol y Drogas para conductores que van a tramitar su licencia por primera vez, es un curso de orientación de 4 horas bajo mandato por el Estado de la Florida. Para ser elegible para un permiso de conducir o licencia de la Florida, todas las personas que serán conductores por primera vez, tales como estudiantes, o quienes nunca han poseído una licencia de conducir en cualquier otro estado o país extranjero deben completar el curso o su equivalente.
                                            </p>
                                        </div>

                                        <p className="mb-3">
                                            En Metro Traffic School, nuestro programa de Alcohol y Drogas para conductores primerizos, se enorgullece en:
                                        </p>
                                        <ul className="mb-4">
                                            <li>Enseñar a nuestros estudiantes a entender cómo el alcohol y otras drogas afectarán a su conducción y su vida en general</li>
                                            <li>Enseñar a nuestros estudiantes a entender la responsabilidad de obtener un permiso de manejo y las leyes que rigen el funcionamiento de cualquier vehículo de motor en el estado de Florida</li>
                                            <li>Enseñar a nuestros estudiantes métodos para que comprendan y utilicen técnicas de conducción seguras</li>
                                            <li>Enseñar a nuestros estudiantes métodos para incrementar la conciencia en los conductores y pasajeros en nuestras carreteras.</li>
                                        </ul>

                                        <p className="mb-3">
                                            El curso de Alcohol y Drogas para conductores primerizos tiene un impacto fundamental para conductores de cualquier edad. Nos mantenemos firmes en nuestro compromiso de transmitir a cada estudiante el conocimiento y herramientas necesarias para evitar convertirse en una parte de los titulares de mañana, a menudo trágicos.
                                        </p>

                                        <p className="mb-4">
                                            A la terminación exitosa del Curso de Alcohol y Drogas para conductores, cada estudiante recibirá un certificado de finalización para asi satisfacer los requisitos del estado de Florida.
                                        </p>

                                        <div className="row justify-content-center py-5">
                                            <div
                                                className="p-4 rounded mb-4 text-center col-12 col-lg-6"
                                                style={{
                                                    backgroundColor: "#252525",
                                                    borderRadius: "8px",
                                                    border: "2px solid var(--metro-yellow)",
                                                }}
                                            >
                                                <h3 className="text-white mb-3">Curso de Alcohol y Drogas</h3>
                                                <div className="mb-3">
                                                    <span
                                                        className="display-5 fw-bold text-warning"
                                                    >
                                                        $19.95
                                                    </span>
                                                </div>
                                                <p className="text-white mb-3">
                                                    Puede hacer el pago con tarjeta de debito o crédito a través de nuestro método de pago seguro.
                                                </p>

                                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                                    <a
                                                        href="https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzgz"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                                                    >
                                                        Registrarme Ahora
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ShellCard>
                        </div>
                    </div>
                </div>
                <div className="container" style={{ marginBottom: "32px" }}>
                    <div className="row text-white">
                        <p>
                            Superb Customer Service
                        </p>
                        <p>
                            At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                        </p>
                    </div>
                </div>
            </main>
        </>
    );
};

export default CursoAlcoholDrogas;
